module.exports = __webpack_public_path__ + "static/media/banner-img.345eb9f2.jpg";